import type { ReactNode } from 'react';
import { PLATFORMS } from '@/constants/platforms';
import { BarChartIcon, LayersIcon, PeopleIcon, SegmentsIcon } from '@/icons';
import type { Platform } from './types';

export const ICONS: Record<Platform, ReactNode> = {
  [PLATFORMS.CRM]: <PeopleIcon />,
  [PLATFORMS.UNISON]: <LayersIcon size={24} strokeWidth={1.9} />,
  [PLATFORMS.INSIGHTS]: <BarChartIcon />,
  [PLATFORMS.SETTINGS]: <SegmentsIcon />,
  [PLATFORMS.PERSPECTIVE]: <LayersIcon size={24} strokeWidth={1.9} />,
};
